export default __webpack_public_path__ + "static/media/8.9153e84c.png";